import type { FaireProductEntity } from "../../entity_types/product";

export const p_vn68tpa9xz: FaireProductEntity = {
  token: "p_vn68tpa9xz",
  type: "product",
  name: "Botanical Corpse Reviver 12pk - Ready-to-Drink",
  brandToken: "b_pgy9sh2kad",
  brandName: "Corpse Reviver",
  imageUrl:
    "https://cdn.faire.com/fastly/9df04e883dca483b276a7517c2ef761d1458d291b65f7bc7e923cad20aa3c508.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eeba1486bcb3cc0e2d52221cdaf7210184d7cde7d4dcc26f0e3fc2ae8b599fa6.png",
    "https://cdn.faire.com/fastly/7cf257a147d4dbea444756f58afc3b09fc8c9ea6363a113fcaeeb18cd50a7f75.png",
    "https://cdn.faire.com/fastly/97a2717c032430523da507a7b5c84d7b384a35139106a24e0dfa45cd3786326b.jpeg",
    "https://cdn.faire.com/fastly/5bf927aff9f0a038d119b051c3e9177d9c210e3fca69bfbc4b946e5fc53ba12d.jpeg",
    "https://cdn.faire.com/fastly/709c56cbd3ddbc32059c1133b6ec1d8ae1e36d342ef7ad9fe401571de2a189ab.jpeg",
  ],
  priceDollars: 20.91,
  description:
    "Crisp hydration with a botanical-inspired flavor, balanced electrolytes, and calming botanicals. Designed to help your body rehydrate and recover.\n\n- Balanced hydration - Electrolytes your body actually uses\n- Herbal refreshment - A crisp botanical taste\n- Calm support - Botanicals and l-theanine that help you feel balanced\n- Clean & simple - No artificial colors, flavors, or sugar. Real juice and tea only\n",
  tags: [],
  msrpDollars: 52.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:58.457Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
